import { useState } from "react";
import { X, Check, NotebookPen } from "lucide-react";

export function NoteEditorModal({ noteDay, initialText, onSave, onClose }) {
  const [noteText, setNoteText] = useState(initialText || "");

  return (
    <div className="fixed inset-0 z-50 bg-zinc-900/50 flex items-center justify-center p-4" data-testid="parent-note-editor-modal">
      <div className="nb-card p-6 w-full max-w-md bg-white">
        <div className="flex items-center justify-between mb-5">
          <h3 className="font-display font-bold text-xl flex items-center gap-2"><NotebookPen className="w-5 h-5" /> {noteDay} note</h3>
          <button onClick={onClose} data-testid="parent-note-editor-close" className="p-1.5 rounded-lg border-2 border-zinc-900 bg-white hover:bg-zinc-100"><X className="w-4 h-4" /></button>
        </div>
        <textarea className="nb-input min-h-[140px] resize-y" data-testid="parent-note-textarea" maxLength={2000}
          placeholder="Homework, kit to bring, reminders…" value={noteText} onChange={(e) => setNoteText(e.target.value)} />
        <button onClick={() => onSave(noteText)} data-testid="parent-note-save-btn" className="nb-btn w-full bg-[#FDE68A] py-2.5 mt-4"><Check className="w-4 h-4" /> Save note</button>
      </div>
    </div>
  );
}
